// API Configuration
// Centraliza todas as URLs da API para facilitar manutenção entre ambientes

export const API_CONFIG = {
  // Base URL da API - pode ser sobrescrita por variável de ambiente
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  
  // Endpoints específicos
  ENDPOINTS: {
    // Trello
    TRELLO: {
      STATUS: '/api/trello/status',
      BOARDS: '/api/trello/boards',
      BOARD_LISTS: (boardId: string) => `/api/trello/boards/${boardId}/lists`,
      BOARD_CARDS: (boardId: string) => `/api/trello/boards/${boardId}/cards`,
      ATTACHMENTS_DOWNLOAD: '/api/trello/attachments/download',
      SAVE_TOKEN: '/api/trello/save-token',
      TEST: '/api/trello/test',
    },
    
    // ClickUp
    CLICKUP: {
      STATUS: '/api/clickup/status',
      WORKSPACES: '/api/clickup/workspaces',
      WORKSPACE_SPACES: (workspaceId: string) => `/api/clickup/workspaces/${workspaceId}/spaces`,
      SPACE_FOLDERS: (spaceId: string) => `/api/clickup/spaces/${spaceId}/folders`,
      FOLDER_LISTS: (folderId: string) => `/api/clickup/folders/${folderId}/lists`,
      LIST_TASKS: (listId: string) => `/api/clickup/lists/${listId}/tasks`,
      ATTACHMENTS_DOWNLOAD: '/api/clickup/attachments/download',
      SAVE_TOKEN: '/api/clickup/save-token',
      TEST: '/api/clickup/test',
      TIME_TRACKING: '/api/clickup/time-tracking',
    },
    
    // Tarefas
    TASKS: {
      CREATE: '/api/tarefas/novo',
    },
  },
  
  // Função helper para construir URLs completas
  buildUrl: (endpoint: string): string => {
    return `${API_CONFIG.BASE_URL}${endpoint}`
  }
}

export default API_CONFIG
